import React from 'react';
import _ from 'lodash';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';

const BilletterieSection = ({ journalVenteData }) => {
    // Utiliser les données du journal de vente pour la billetterie
    const billetterieData = journalVenteData || [];

    // Filtrer les données de billetterie
    const billetterieFiltered = billetterieData.filter(item =>
        item.type_transaction === 'billetterie' ||
        item.service === 'billetterie' ||
        !item.type_transaction // Si pas de type spécifié, prendre toutes les données
    );

    // Utiliser les données filtrées ou toutes si pas de filtrage spécifique
    const dataToUse = billetterieFiltered.length > 0 ? billetterieFiltered : billetterieData;

    const totalCA = _.sumBy(dataToUse, item => Number(item.montant_vente) || Number(item.tarif) || 0);
    const totalDebours = _.sumBy(dataToUse, item => Number(item.montant_achat) || Number(item.debours) || 0);
    const margeTotal = totalCA - totalDebours;

    // Groupement par compagnie ou prestataire
    const groupingField = dataToUse[0]?.compagnie !== undefined ? 'compagnie' :
        dataToUse[0]?.prestataire !== undefined ? 'prestataire' :
            'fournisseur';

    const groupedByCompany = _.groupBy(dataToUse, groupingField);
    const companyStats = Object.keys(groupedByCompany).map(company => {
        const items = groupedByCompany[company];
        const ca = _.sumBy(items, item => Number(item.montant_vente) || Number(item.tarif) || 0);
        const debours = _.sumBy(items, item => Number(item.montant_achat) || Number(item.debours) || 0);
        const marge = ca - debours;
        const count = items.length;
        const pourcentageCA = totalCA > 0 ? ((ca / totalCA) * 100).toFixed(1) : 0;
        const pourcentageMarge = ca > 0 ? ((marge / ca) * 100).toFixed(1) : 0;

        return {
            company,
            ca,
            debours,
            marge,
            count,
            pourcentageCA,
            pourcentageMarge
        };
    }).sort((a, b) => b.ca - a.ca);

    return (
        <div className="analysis-section">
            <SectionHeader
                title="🎫 ANALYSE BILLETTERIE"
                pdfData={companyStats.map(item => ({
                    metrique: item.company,
                    montant: item.ca,
                    pourcentage: `${item.pourcentageMarge}%`,
                    marge: item.marge
                }))}
                pdfFilename="analyse-billetterie.pdf"
                pdfTitle="Analyse Billetterie"
                pdfTableHeaders={["Compagnie", "CA", "% Marge", "Marge"]}
            />

            <div className="table-container-prof">
                <div className="table-title-prof">SYNTHESE BILLETTERIE GENERALE</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">INDICATEUR</th>
                            <th className="text-right">MONTANT</th>
                            <th className="text-right">POURCENTAGE</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>CHIFFRE D'AFFAIRES</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCA)}</td>
                            <td className="percentage-cell">100.0%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>DEBOURS</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalDebours)}</td>
                            <td className="percentage-cell">{totalCA > 0 ? ((totalDebours / totalCA) * 100).toFixed(1) : 0}%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>MARGE</strong></td>
                            <td className="currency-cell">{priceFormatterV3(margeTotal)}</td>
                            <td className="percentage-cell">{totalCA > 0 ? ((margeTotal / totalCA) * 100).toFixed(1) : 0}%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>NOMBRE DE BILLETS</strong></td>
                            <td className="number-cell">{billetterieData.length}</td>
                            <td className="percentage-cell">-</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="table-container-prof">
                <div className="table-title-prof">CHIFFRE D'AFFAIRES, MARGE ET POURCENTAGE PAR COMPAGNIE</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">COMPAGNIE</th>
                            <th className="text-right">NB BILLETS</th>
                            <th className="text-right">CHIFFRE D'AFFAIRES</th>
                            <th className="text-right">DEBOURS</th>
                            <th className="text-right">MARGE</th>
                            <th className="text-right">% MARGE</th>
                            <th className="text-right">% DU CA TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {companyStats.map((company, index) => (
                            <tr key={index}>
                                <td className="text-left"><strong>{company.company}</strong></td>
                                <td className="number-cell">{company.count}</td>
                                <td className="currency-cell">{priceFormatterV3(company.ca)}</td>
                                <td className="currency-cell">{priceFormatterV3(company.debours)}</td>
                                <td className="currency-cell">{priceFormatterV3(company.marge)}</td>
                                <td className="percentage-cell">{company.pourcentageMarge}%</td>
                                <td className="percentage-cell">{company.pourcentageCA}%</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className="total-row-prof">
                            <td className="text-left"><strong>TOTAL</strong></td>
                            <td className="number-cell">{billetterieData.length}</td>
                            <td className="currency-cell">{priceFormatterV3(totalCA)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDebours)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeTotal)}</td>
                            <td className="percentage-cell">{totalCA > 0 ? ((margeTotal / totalCA) * 100).toFixed(1) : 0}%</td>
                            <td className="percentage-cell">100.0%</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default BilletterieSection;
